const testimonials = [
  {
    id: 1,
    imageUrl: "review1.jpeg",
    name: "Rahul Varma",
    title: "Excellent Service!",
    subName: "Verified Buyer",
    designation: "Regular Customer",
    rating: 5,
    desc: "Ordering my medicines online was quick and hassle-free. The products arrived on time, were well-packaged, and exactly as described. I'll definitely order again."
  },
  {
    id: 2,
    imageUrl: "review2.jpeg",
    name: "Aditya Sharma",
    title: "Fast Delivery",
    subName: "Happy Customer",
    designation: "Working Professional",
    rating: 4.5,
    desc: "I received my prescription medicines within a day. The ordering process was simple, and the customer support team was very helpful throughout."
  },
  {
    id: 3,
    imageUrl: "review3.jpeg",
    name: "Arjun Mehta",
    title: "Highly Recommended",
    subName: "Loyal Customer",
    designation: "Healthcare Enthusiast",
    rating: 5,
    desc: "The pharmacy offers genuine products at competitive prices. I especially appreciate the easy prescription upload feature and secure packaging."
  },
  {
    id: 4,
    imageUrl: "review4.jpeg",
    name: "Rohan Kapoor",
    title: "Great Experience",
    subName: "Verified Buyer",
    designation: "Bodybuilding Enthusiast",
    rating: 5,
    desc: "I've been ordering medicines and wellness products regularly. The discounts are excellent, delivery is always on time, and every order has been accurate."
  },
];

export { testimonials };